import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the change password view.
 * @extends JetView
 */
export default class changePasswordView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Configuration for the left section containing the new password input
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for new password
                    name: 'NewPassword',
                    type: 'password',
                    id: 'NewPassword',
                    label: _('Nueva Contraseña'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Nueva Contraseña'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: _(
                        'La contraseña debe contener mínimo 8 caracteres, una minúscula, una mayúscula y un número.', // Validation message
                    ),
                    /**
                     * Validates the new password based on length and character types.
                     * @param {string} value - The password value to validate.
                     * @returns {boolean} True if valid, otherwise false.
                     */
                    validate: function (value) {
                        return (
                            value.length >= 8 && // Minimum length
                            /[a-z]/.test(value) && // At least one lowercase letter
                            /[A-Z]/.test(value) && // At least one uppercase letter
                            /[0-9]/.test(value) // At least one number
                        );
                    },
                    on: {
                        /**
                         * Validates the password field on blur event.
                         */
                        onBlur: function () {
                            $$('NewPassword').validate(); // Trigger validation
                        },
                    },
                },
            ],
        };

        // Configuration for the right section containing the confirm password input
        const right = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for confirming password
                    name: 'ConfirmPassword',
                    type: 'password',
                    id: 'ConfirmPassword',
                    label: _('Confirmar Contraseña'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Confirmar Contraseña'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: _('Contraseñas no coinciden'), // Validation message
                    /**
                     * Validates the confirm password against the new password.
                     * @param {string} value - The confirm password value to validate.
                     * @returns {boolean} True if it matches the new password, otherwise false.
                     */
                    validate: function (value) {
                        return value == $$('NewPassword').getValue(); // Check if it matches
                    },
                    on: {
                        /**
                         * Validates the confirm password field on blur event.
                         */
                        onBlur: function () {
                            $$('ConfirmPassword').validate(); // Trigger validation
                        },
                    },
                },
            ],
        };

        // Upper section layout combining left and right sections
        const upper_section = {
            cols: [
                center_left,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        // Button configuration for form actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    /**
                     * Clears the form fields and validation on click.
                     */
                    click: () => {
                        $$('formChangePassword').setValues(
                            $$('formChangePassword').getCleanValues(), // Reset values
                        );
                        $$('formChangePassword').clearValidation(); // Clear validation
                    },
                },
                {
                    view: 'button', // Save button
                    value: _('Guardar'), // Button label
                    type: 'form',
                    autowidth: true,
                    /**
                     * Validates and submits the form on click.
                     */
                    click: () => {
                        if (this.getRoot().validate()) {
                            // Validate form
                            const newPassword = this.getRoot().getValues(); // Get form values
                            const cur_user = this.getParam('user', true); // Get current user parameter
                            if (
                                newPassword.NewPassword === newPassword.ConfirmPassword // Check if passwords match
                            ) {
                                webix.confirm({
                                    type: 'confirm-warning',
                                    text: _('Advertencia!') + '<br/>' + _('Desea cambiar la contraseña?'), // Confirmation message
                                    ok: _('Cambiar Contraseña'), // OK button label
                                    cancel: _('Salir'), // Cancel button label
                                    /**
                                     * Callback for confirmation dialog.
                                     * @param {boolean} action - The action taken by the user.
                                     */
                                    callback: function (action) {
                                        if (action === true) {
                                            // If confirmed
                                            const data = {
                                                FromId: cur_user, // Current user ID
                                                NewPassword: newPassword.NewPassword, // New password
                                                ConfirmPassword: newPassword.ConfirmPassword, // Confirm password
                                            };
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'AgentList/ChangePassword', // API endpoint
                                                    data,
                                                    {
                                                        /**
                                                         * Handles error response from the server.
                                                         * @param {string} text - The response text.
                                                         * @param {Object} data - The response data.
                                                         * @param {XMLHttpRequest} XmlHttpRequest - The XMLHttpRequest object.
                                                         */
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error', // Display error message
                                                            );
                                                        },
                                                        /**
                                                         * Handles success response from the server.
                                                         * @param {string} text - The response text.
                                                         * @param {Object} data - The response data.
                                                         * @param {XMLHttpRequest} XmlHttpRequest - The XMLHttpRequest object.
                                                         */
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(
                                                                text, // Parse JSON response
                                                            );
                                                            if (json.HasError) {
                                                                // Check for errors
                                                                if (json.CodeError != 110012) {
                                                                    webix.message({
                                                                        text: json.AlertMessage, // Display alert message
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                    });
                                                                }
                                                            } else {
                                                                webix.message({
                                                                    text: _(
                                                                        'Contraseña cambiada satisfactoriamente', // Success message
                                                                    ),
                                                                    title: _('¡Exito!'),
                                                                    type: 'alert-warning',
                                                                });
                                                                $$('formChangePassword').setValues(
                                                                    $$('formChangePassword').getCleanValues(), // Reset values
                                                                );
                                                                $$('formChangePassword').clearValidation(); // Clear validation
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                });
                            } else {
                                webix.message({
                                    title: _('¡Error!'), // Error title
                                    type: 'alert-error',
                                    text: _('Contraseñas no coinciden'), // Error message
                                });
                            }
                        } else {
                            webix.message({
                                title: _('¡Error!'), // Error title
                                type: 'alert-error',
                                text: _('Completa los campos...'), // Error message
                            });
                        }
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'formChangePassword', // Form ID
            rows: [upper_section, buttons], // Form layout
        };
    }
}

// FILE DOCUMENTED
